import { logger } from '../logger';

export function catchAdapterError<T>(feature: string, defaultReturn?: T): (error: any) => T {
  return error => {
    if (error.code === DOMException.ABORT_ERR) {
      logger.warn(`[${ feature }] Request has been cancelled`);
    } else {
      logger.error(`[${ feature }]`, error);
    }
    return defaultReturn;
  };
}
